import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import EntityInterface from 'common/types/entities/EntityInterface'
import React from 'react'
import {
  ObjectPropertyPath,
  setObjectProperty,
} from 'src/editor/shared/utils/set-object-property'
import { Repeat04Icon } from '../icons/repeat-04-icon'
import { ButtonSizeEnum, GhostIconButton } from '../ui-lib/buttons'

export type ResetEntityStylesProps<Entity extends Partial<EntityInterface>> = {
  className?: string
  entity: Entity
  defaultEntity: Entity | undefined
  keys: Array<ObjectPropertyPath<Entity>>
  mobileKeys?: Array<ObjectPropertyPath<Entity>>
}

export const ResetEntityStyles = <Entity extends Partial<EntityInterface>>({
  className,
  entity,
  defaultEntity,
  keys,
  mobileKeys,
}: ResetEntityStylesProps<Entity>) => {
  const { isMobile } = useDeviceModeContext()

  const currentKeys = isMobile ? mobileKeys || keys : keys

  const updateEntity = useUpdateEntity<Entity>()
  const onResetStyles = () => {
    if (defaultEntity) {
      updateEntity(
        currentKeys.reduce(
          (acc, key) => setObjectProperty(acc, defaultEntity, key),
          entity as Entity,
        ),
      )
    }
  }

  return (
    defaultEntity && (
      <GhostIconButton
        className={className}
        size={ButtonSizeEnum.Small}
        onClick={onResetStyles}
        icon={<Repeat04Icon />}
      />
    )
  )
}
